import { createNoise } from "../noise.js";
import applyPlateau from "./plateau.js";
import applyCanyon from "./canyon.js";
import applyValley from "./valley.js";
import applyPlains from "./plains.js";
import applyDunes from "./dunes.js";
import applyCrater from "./crater.js";
import applyMountains from "./mountains.js";

const FEATURES = {
    plateau: { kind: "constructive", apply: applyPlateau },
    canyon: { kind: "destructive", apply: applyCanyon },
    valley: { kind: "destructive", apply: applyValley },
    plains: { kind: "constructive", apply: applyPlains },
    dunes: { kind: "constructive", apply: applyDunes },
    crater: { kind: "constructive", apply: applyCrater },
    mountains: { kind: "constructive", apply: applyMountains },
};

export const FEATURE_TYPES = Object.keys(FEATURES);

export function featureKind(type) {
    return FEATURES[type]?.kind ?? "constructive";
}

export function defaultParams(type) {
    if (type === "plateau") return { terraces: 4 };
    if (type === "canyon") return { meander: 0.35 };
    if (type === "dunes") return { frequency: 5 };
    return {};
}

export function defaultFeature(type, x, z) {
    const height = {
        plateau: 48,
        canyon: 22,
        valley: 14,
        plains: 18,
        dunes: 7,
        crater: 16,
        mountains: 36,
    }[type] ?? 20;

    return {
        id: `f${Date.now().toString(36)}${Math.floor(Math.random() * 1000).toString(36)}`,
        type,
        x,
        z,
        sx: type === "canyon" ? 180 : 90,
        sz: type === "canyon" ? 70 : 70,
        rotation: 0,
        height,
        strength: 1,
        seed: Math.floor(Math.random() * 9000) + 1,
        params: defaultParams(type),
    };
}

export function applyFeature(heights, resolution, layoutSize, feature) {
    const fn = FEATURES[feature.type]?.apply;
    if (!fn) return;
    const noise = createNoise((feature.seed >>> 0) + 17);
    fn(heights, resolution, layoutSize, feature, noise);
}
